<ul class="page-secondary-navigation__list">
    <li class="page-secondary-navigation__item" #listElement>
        <a
            class="page-secondary-navigation__item-link"
            [class.is-active]="navigationData.url === currentRouteUrl"
            [routerLink]="navigationData.url"
        >
            <span
                class="page-secondary-navigation__item-text"
                [innerText]="
                    'new_vehicles.vehicle_model_page_sub_navigation_home_button_text' | translate
                "
            ></span>
        </a>
    </li>
    <li
        class="page-secondary-navigation__item"
        #listElement
        *ngFor="let item of navigationData.children"
    >
        <a
            class="page-secondary-navigation__item-link"
            [class.is-active]="item.url === currentRouteUrl"
            [routerLink]="item.url"
        >
            <span class="page-secondary-navigation__item-text" [innerText]="item.name"></span>
        </a>
    </li>
</ul>
